import { VStack, Heading, Text } from "@chakra-ui/react";
function DaosPage() {
	return (
		<VStack
			padding={10}
			alignContent="center"
			height="100%"
			width="100%"
			justifyContent="center"
		>
			<Heading size="md">Creators DAOs Coming Soon</Heading>
			<Text textAlign="center">
				Join your favourite creator DAOs and govern their profiles
			</Text>
		</VStack>
	);
}

export default DaosPage;
